import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import RoomLobby from './components/RoomLobby';
import GameBoard from './components/GameBoard';
import { getAccessToken, clearTokens, checkToken, getCurrentUserAccount, getCurrentUserId } from './services/authService';
import { GameProvider, useGame } from './contexts/GameContext';
import './App.css';

function GameContent() {
  const { isPlaying, gameState } = useGame();

  // 根据游戏状态显示不同界面
  const shouldShowGameBoard = isPlaying || gameState?.status === 'finished';
  if (shouldShowGameBoard) {
    return <GameBoard />;
  }
  const nickname = getCurrentUserAccount() || `Player${getCurrentUserId()}`; // 使用手机号或 UID 作为昵称

  return <RoomLobby nickname={nickname} />;
}

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // 检查用户是否已登录
    const checkAuth = async () => {
      const token = getAccessToken();
      if (token) {
        try {
          await checkToken();
          setIsAuthenticated(true);
        } catch (err) {
          clearTokens();
          setIsAuthenticated(false);
        }
      }
      setIsLoading(false);
    };

    checkAuth();
  }, []);

  const handleLoginSuccess = (data) => {
    console.log('登录成功:', data);
    setIsAuthenticated(true);
  };

  const handleLogout = () => {
    clearTokens();
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div className="App">
        <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh'
        }}>
          加载中...
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {!isAuthenticated ? (
        <Login onLoginSuccess={handleLoginSuccess} />
      ) : (
        <GameProvider>
          <GameContent />
        </GameProvider>
      )}
    </div>
  );
}

export default App;
